import { useEffect } from "react";
import { useSettings, useRoom } from "@turnaroundfactor/react";
import { languages } from "../data/languages";

export default function TranslationSettings() {
	const { update: updateSettings, settings } = useSettings();
	const {
		language,
		voice,
		translationEnabled,
		translationAudioEnabled,
		audioEnabled,
		videoEnabled,
	} = settings;
	const { broadcast } = useRoom();

	function updateVoice(value) {
		if (value) updateSettings({ voice: value });
	}

	// useEffect(() => {
	// 	broadcast("LOCAL_STATE", {
	// 		translate: translationEnabled ? language : null,
	// 		audio: audioEnabled,
	// 		vidoe: videoEnabled,
	// 	});
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [translationEnabled, language]);

	return (
		<>
			<div className="form-group">
				<button
					type="button"
					className="form-control text-left btn-sm"
					style={{ outline: 0, boxShadow: "none" }}
					onClick={() =>
						updateSettings({ translationEnabled: !translationEnabled })
					}
				>
					<i
						className={`mr-2 far fa-fw ${
							translationEnabled ? "fa-check-square" : "fa-square"
						}`}
					/>
					Enable Translations
				</button>
			</div>
			<div className="form-group">
				<label
					htmlFor="language-select"
					className="form-label font-weight-bold"
				>
					Preferred Language
				</label>
				<select
					name="toLanguage"
					id="language-select"
					className="form-control select"
					required
					disabled={translationEnabled}
					defaultValue={language}
					aria-describedby="preferredLanguageBlock"
					onChange={(e) => updateSettings({ language: e.target.value || "en" })}
				>
					<option value="">Select a language</option>
					{languages.map((languageobj) => (
						<option value={languageobj.code} key={`to_${languageobj.code}`}>
							{languageobj.language}
						</option>
					))}
				</select>
				<span
					className="form-text text-muted"
					style={{ fontSize: "0.8rem" }}
					id="preferredLanguageBlock"
				>
					Audio will be translated into this language
				</span>
			</div>
			<div className="form-group">
				<div className="form-check form-check-inline">
					<input
						className="form-check-input"
						type="checkbox"
						id="translationOptionAudio"
						defaultChecked={translationAudioEnabled}
						onChange={(e) =>
							updateSettings({
								translationAudioEnabled: e.target.checked,
							})
						}
					/>
					<label htmlFor="translationOptionAudio" className="form-check-label">
						Play translated audio
					</label>
				</div>
			</div>
			{translationAudioEnabled && (
				<div className="form-group">
					<label className="form-label d-block mb-2 font-weight-bold">
						Voice
					</label>
					<div className="form-check form-check-inline">
						<input
							className="form-check-input"
							type="radio"
							name="audioVoice"
							disabled={translationEnabled}
							defaultChecked={voice === "male"}
							value="male"
							id="translationOptionMale"
							onChange={(e) => updateVoice(e.target.checked ? "male" : null)}
						/>
						<label htmlFor="translationOptionMale" className="form-check-label">
							Male
						</label>
					</div>
					<div className="form-check form-check-inline">
						<input
							className="form-check-input"
							type="radio"
							name="audioVoice"
							disabled={translationEnabled}
							defaultChecked={voice === "female"}
							value="female"
							id="translationOptionFemale"
							onChange={(e) => updateVoice(e.target.checked ? "female" : null)}
						/>
						<label
							htmlFor="translationOptionFemale"
							className="form-check-label"
						>
							Female
						</label>
					</div>
				</div>
			)}
		</>
	);
}
